import type {
    AudioDetailsStockItem,
    AudioStockItem,
    GraphicStockItem,
    VideoStockItem,
} from '@videoblocks/search-gateway-client';

export * from './src';

export type StockItem = AudioStockItem | VideoStockItem | GraphicStockItem;

export type DetailsStockItem = AudioDetailsStockItem; // | VideoDetailsStockItem | GraphicDetailsStockItem;

export * from '@videoblocks/search-gateway-client';
